module.exports = __webpack_public_path__ + "static/media/timer_1.e98d2270.mp3";